import FootballState from "../../../../../sports/football/state/football-state";
import FootballStringifier from "../../../../stringifiers/football-stringifier";
import { FragmentSerializer } from "./FragmentSerializer";

export class TimeFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.SetTimeAndPeriod;
    }

    getRawFragment(play, serializationContext) {
        let rawPlay = "";

        rawPlay = `T:${FootballStringifier.milisecondsToMMSS(
            serializationContext.gameContext.gameClock.now()
        )}`;

        return rawPlay;
    }
}
